{
  "loading": "読み込み中...",
  "placeholder": "オプションを選択..."
}